import axios from '../../axios'

/*
 * 考场编排数据接口
 */

// 获取考场编排列表
export const getArrangeList = (data) => {
    return axios({
        url: '/api/mock/aff/arrange',
        method: 'get',
        data
    })
}

// 编排考场
export const saveArrange = (data) => {
    return axios({
        url: '/api/mock/aff/arrange',
        method: 'post',
        data
    })
}

// 撤销编排
export const deleteArrange = (data) => {
    return axios({
        url: '/api/mock/aff/arrange',
        method: 'delete',
        data
    })
}

// 获取考场学生列表
export const getRoomStudentList = (data) => {
    return axios({
        url: '/api/mock/aff/room_student',
        method: 'get',
        data
    })
}

// 导入考场
/** *
 *
 * provinceId
 * examId
 * areaId
 * filePath
 * originName
 *
 * **/
export const importRoom = (data) => {
    return axios({
        url: '/api/mock/aff/import_room',
        method: 'post',
        data
    })
}

// 手动编排考场
/** *
 *
 * examId 考试ID
 * areaId 考区ID
 * arrangeIds 选择考场ID列表
 *
 * **/

export const selectArrange = (data) => {
    return axios({
        url: '/api/mock/aff/select_arrange',
        method: 'post',
        data
    })
}

export const roomList = (data) => {
    return axios({
        url: '/api/mock/aff/room_list',
        method: 'post',
        data
    })
}

// 批量删除考场
/** **
 *
 * examId 考试ID
 * batch 批次
 *
 *
 * ***/
export const deleteBatchRoom = (data) => {
    return axios({
        url: '/api/mock/aff/delete_batch_room',
        method: 'DELETE',
        data
    })
}

// 准考证下载
export const downloadTicket = (data) => {
    return axios({
        url: '/api/mock/aff/download_ticket',
        method: 'GET',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/aff/arrange.js